import i18n from '@/common/i18n';
import computedLocale from '@/common/utils/computedLocale';

export default computedLocale(() => ({
  room: {
    createTitle: i18n.t('Create room'),
    locationNameFieldLabel: i18n.t('Room name'),
    noItems: i18n.t('No rooms to show'),
    noItemsDescription: i18n.t('Rooms that you create will be shown here.'),
    singleItemDeleteConfirmation: name => i18n.t('Are you sure that you want to delete the room "{name}"?', { name }),
    multiItemsDeleteConfirmation: i18n.t('Are you sure that you want to delete these rooms?'),
    columnName: i18n.t('Rooms'),
    redundancyDomain: i18n.t('Room'),
    redundancyTooltip: num => i18n.t('Add rooms: {num}', { num }),
    moveToDescription: count => i18n.tc('Choose a room where to move the selected node to.|Choose a room where to move the selected nodes to.', count)
  },
  row: {
    createTitle: i18n.t('Create row'),
    locationNameFieldLabel: i18n.t('Row name'),
    noItems: i18n.t('No rows to show'),
    noItemsDescription: i18n.t('Rows that you create will be shown here.'),
    singleItemDeleteConfirmation: name => i18n.t('Are you sure that you want to delete the row "{name}"?', { name }),
    multiItemsDeleteConfirmation: i18n.t('Are you sure that you want to delete these rows?'),
    columnName: i18n.t('Rows'),
    redundancyDomain: i18n.t('Row'),
    redundancyTooltip: num => i18n.t('Add rows: {num}', { num }),
    moveToDescription: count => i18n.tc('Choose a row where to move the selected node to.|Choose a row where to move the selected nodes to.', count)
  },
  rack: {
    createTitle: i18n.t('Create rack'),
    locationNameFieldLabel: i18n.t('Rack name'),
    noItems: i18n.t('No racks to show'),
    noItemsDescription: i18n.t('Racks that you create will be shown here.'),
    singleItemDeleteConfirmation: name => i18n.t('Are you sure that you want to delete the rack "{name}"?', { name }),
    multiItemsDeleteConfirmation: i18n.t('Are you sure that you want to delete these racks?'),
    columnName: i18n.t('Racks'),
    redundancyDomain: i18n.t('Rack'),
    redundancyTooltip: num => i18n.t('Add racks: {num}', { num }),
    moveToDescription: count => i18n.tc('Choose a rack where to move the selected node to.|Choose a rack where to move the selected nodes to.', count)
  },
  zone: {
    createTitle: i18n.t('Create zone'),
    locationNameFieldLabel: i18n.t('Zone name'),
    noItems: i18n.t('No zones to show'),
    noItemsDescription: i18n.t('Zones that you create will be shown here.'),
    singleItemDeleteConfirmation: name => i18n.t('Are you sure that you want to delete the zone "{name}"?', { name }),
    multiItemsDeleteConfirmation: i18n.t('Are you sure that you want to delete these zones?'),
    columnName: i18n.t('Zones'),
    redundancyDomain: i18n.t('Zone'),
    redundancyTooltip: num => i18n.t('Add zones: {num}', { num }),
    moveToDescription: count => i18n.tc('Choose a zone where to move the selected node to.|Choose a zone where to move the selected nodes to.', count)
  },
  enclosure: {
    createTitle: i18n.t('Create enclosure'),
    locationNameFieldLabel: i18n.t('Enclosure name'),
    noItems: i18n.t('No enclosures to show'),
    noItemsDescription: i18n.t('Enclosures that you create will be shown here.'),
    singleItemDeleteConfirmation: name => i18n.t('Are you sure that you want to delete the enclosure "{name}"?', { name }),
    multiItemsDeleteConfirmation: i18n.t('Are you sure that you want to delete these enclosures?'),
    columnName: i18n.t('Enclosures'),
    redundancyDomain: i18n.t('Enclosure'),
    redundancyTooltip: num => i18n.t('Add enclosures: {num}', { num }),
    moveToDescription: count => i18n.tc('Choose an enclosure where to move the selected node to.|Choose an enclosure where to move the selected nodes to.', count)
  },
  chassis: {
    createTitle: i18n.t('Create chassis'),
    locationNameFieldLabel: i18n.t('Chassis name'),
    noItems: i18n.t('No chassis to show'),
    noItemsDescription: i18n.t('Chassis that you create will be shown here.'),
    singleItemDeleteConfirmation: name => i18n.t('Are you sure that you want to delete the chassis "{name}"?', { name }),
    multiItemsDeleteConfirmation: i18n.t('Are you sure that you want to delete these chassis?'),
    columnName: i18n.t('Chassis'),
    redundancyDomain: i18n.t('Chassis'),
    redundancyTooltip: num => i18n.t('Add chassis: {num}', { num }),
    moveToDescription: count => i18n.tc('Choose a chassis where to move the selected node to.|Choose a chassis where to move the selected nodes to.', count)
  },
  'blade server': {
    createTitle: i18n.t('Create blade server'),
    locationNameFieldLabel: i18n.t('Blade server name'),
    noItems: i18n.t('No blade servers to show'),
    noItemsDescription: i18n.t('Blade servers that you create will be shown here.'),
    singleItemDeleteConfirmation: name => i18n.t('Are you sure that you want to delete the blade server "{name}"?', { name }),
    multiItemsDeleteConfirmation: i18n.t('Are you sure that you want to delete these blade servers?'),
    columnName: i18n.t('Blade servers'),
    redundancyDomain: i18n.t('Blade server'),
    redundancyTooltip: num => i18n.t('Add blade servers: {num}', { num }),
    moveToDescription: count => i18n.tc('Choose a blade server where to move the selected node to.|Choose a blade server where to move the selected nodes to.', count)
  },
  unknown: locationName => ({
    createTitle: i18n.t('Create location'),
    locationNameFieldLabel: i18n.t('Location name'),
    noItems: i18n.t('No locations to show'),
    noItemsDescription: i18n.t('Locations that you create will be shown here.'),
    singleItemDeleteConfirmation: name => i18n.t('Are you sure that you want to delete "{name}"?', { name }),
    multiItemsDeleteConfirmation: i18n.t('Are you sure that you want to delete these locations?'),
    columnName: i18n.t('Locations'),
    redundancyDomain: locationName,
    redundancyTooltip: num => i18n.t('Add locations: {num}', { num }),
    moveToDescription: count => i18n.tc('Choose a location where to move the selected node to.|Choose a location where to move the selected nodes to.', count)
  })
}));
